/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendDiscountRateDto } from '../../models/backend-discount-rate-dto';
import { BackendDiscountRateRequestDto } from '../../models/backend-discount-rate-request-dto';

export interface ProjectTaxesDiscountRatesCreate$Params {
  body: BackendDiscountRateRequestDto;
}

export function projectTaxesDiscountRatesCreate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesDiscountRatesCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesDiscountRatesCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendDiscountRateDto>;
    }),
  );
}

projectTaxesDiscountRatesCreate.PATH = '/api/project_taxes/discount_rates/';
